import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import { bootstrap } from './app/bootstrap';
import './styles/globals.css';

bootstrap()
  .catch((error) => {
    console.error('[bootstrap] Fatal:', error);
  })
  .finally(() => {
    const root = document.getElementById('root');
    if (!root) throw new Error('[main] Missing #root');
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  });
